import { Injectable, ComponentRef } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Datos, PreviewDialogConfig } from './overlayLoaderConfig';
import { OverlayService } from './overlay.service';
import { InstitucionGmapComponent } from 'src/app/components/globales/institucion-gmap/institucion-gmap.component';
const DEFAULT_CONFIG = {
  hasBackdrop: true,
};
@Injectable({
  providedIn: 'root',
})
export class OverlayGmapService {
  dialogRef!: OverlayRef;
  compRef!: ComponentRef<InstitucionGmapComponent>;
  constructor(
    private overlay: Overlay,
    private overlayService: OverlayService
  ) {}
  open(data?: Datos) {
    if (this.dialogRef) {
      this.close();
    }
    [this.dialogRef, this.compRef] = this.openLoader({
      data,
    });
    if (this.dialogRef.overlayElement.parentElement) {
      this.dialogRef.overlayElement.parentElement.className += ' super';
    }
  }
  close() {
    if (this.dialogRef) {
      this.dialogRef.dispose();
    }
  }
  openLoader(config: PreviewDialogConfig = {}) {
    // Override default configuration
    const dialogConfig = { ...DEFAULT_CONFIG, ...config };
    // Returns an OverlayRef which is a PortalHost
    const positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();
    const overlayRef = this.overlayService.createOverlay(
      dialogConfig,
      positionStrategy
    );
    // Instantiate remote control
    const dialogRef = overlayRef;
    const overlayComponent: any = this.overlayService.attachContainer(
      overlayRef,
      dialogConfig,
      dialogRef,
      InstitucionGmapComponent,
    );
    return [dialogRef, overlayComponent];
  }
}
